<app-card-expand-icon [open]="open"></app-card-expand-icon>
